import MediaTypes from "@/react/features/vcc/types/mediaTypes";

const NUMERIC_ATTRIBUTES = Object.freeze([
  "post_processing_timeout",
  "sla_evaluation_interval",
]);

/**
 * Converts numeric strings to numbers for certain attributes.
 * NOTE: We have some numeric columns with TYPE.SELECT. These
 *  will always provide strings due to implementation details
 *  of the selector. We want to send them as numbers to the
 *  API.
 */
const convertNumericAttributes = (row) => {
  const result = { ...row };
  for (const field of NUMERIC_ATTRIBUTES) {
    if (field in row) {
      result[field] = parseInt(row[field], 10);
    }
  }

  return result;
};

const transformInboundQueuesData = (rows, shouldCopyIdFromKey = false) => {
  if (!(rows instanceof Map)) {
    throw new Error("Expected rows to be of type Map");
  }

  return Array.from(rows.values()).map((row) => {
    let _row = { ...row };
    _row.media_type = MediaTypes.INBOUND_PHONE;

    // We need to copy _key into id for Create operations. _key is
    // generated by the table and injected into the row object to
    // distinguish between entities which do not yet have a DB id.
    if (shouldCopyIdFromKey) {
      _row.id = row._key;
    }

    if ("errors" in _row) {
      delete _row.errors;
    }

    _row = convertNumericAttributes(_row);

    return _row;
  });
};

export default transformInboundQueuesData;
